const UserPage = () => {
  return (
    <div className="p-10">
      <h1 className="text-3xl text-teal-800 font-bold">User placeholder page</h1>
    </div>
  )
}

export default UserPage
